import React from 'react';
import { Button, FormGroup, Row, Col } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { PhoneBox } from "areas/shared/controls";
import { Label } from 'fw/components';

export const renderPhones = (form, handlePhoneChange, handleAddPhone, handleRemovePhone) => {
	return (
		<Row>
			<Col md={12}>
				{form.phones != null && form.phones.length > 0 &&
					<FormGroup>
						<Label htmlFor="phoneNumber" required={!form.doNotSolicit}>Phone Number(s)</Label>
						{form.phones.map((p, i) =>
							<div key={p.phoneId} className="form-inline" >
								<PhoneBox
									value={p}
									showExtension
									onChange={(v) => handlePhoneChange(v, i)}
									ref={`phone_${i}`} />
								<Button
									bsStyle="link"
									onClick={() => handleRemovePhone(i)}><FontAwesomeIcon icon={faTimes} /></Button>
							</div>)
						}
					</FormGroup>
				}
				{form.phones != null && form.phones.length < 5 &&
					<Button type="button" bsStyle="link" onClick={handleAddPhone}>
						Add another Phone
					</Button>
				}
			</Col>
		</Row>
	);
}


// WEBPACK FOOTER //
// ./src/areas/shared/helpers/BusinessStaffPopUpHelpers.js